<script setup lang="ts">
const { $fetchApi }: any = useNuxtApp();
type TestimonialType = {
  id: number;
  name: string;
  rating: number;
  description: string;
  created_at: string;
  images: string;
};

const testimonials = ref<TestimonialType[]>([]);
const breakpoints = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
};

const { isSmallScreen } = useBreakpoints({
  breakpoints,
  initialWidth: 0,
  mediumBreakPoint: "md",
  largeBreakPoint: "lg",
});

try {
  const { status, data } = await $fetchApi("/cms/testimonials/get");
  if (status) {
    testimonials.value = data.data;
  }
} catch (error) {
  console.error("Error get testimonials");
}
</script>

<template>
  <div class="py-12 sm:p-12 bg-white">
    <div class="container">
      <div class="flex items-start gap-8 grid grid-cols-1 sm:grid-cols-2">
        <div class="flex flex-col h-full">
          <NuxtImg
            :quality="30"
            src="/assets/logo-bali-bikes-main-hz.png"
            alt="logo-balibikes"
            class="w-64 mb-4 mx-auto sm:mx-0"
          />
          <div>
            <h2 class="text-2xl mb-2 font-semibold">
              Experiences Shared by Our Clients
            </h2>
            <p>
              Service is superb and bike is in very condition! Will definitely
              consider this again! Thank you for your wonderful service
            </p>
          </div>

          <div class="mt-8">
            <Icon
              name="material-symbols:star-rounded"
              v-for="(_, i) in 5"
              class="size-5 text-yellow-500"
            />
            5/5 - (74 votes)
          </div>
        </div>
        <div class="w-full">
          <ClientOnly>
            <Swiper
              id="swiper-testimonials"
              :modules="[
                SwiperA11y,
                SwiperAutoplay,
                SwiperNavigation,
                SwiperPagination,
              ]"
              :slides-per-view="3"
              loop
              :pagination="{
                clickable: true,
              }"
              :space-between="20"
              class="container"
              autoplay
              :breakpoints="{
                0: {
                  slidesPerView: 2.2,
                },
                640: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 3,
                },
                1024: {
                  slidesPerView: 3,
                },
              }"
            >
              <SwiperSlide
                v-for="(item, i) in testimonials"
                :key="i"
                class="flex !h-auto bg-transparent justify-center flex-col items-center"
              >
                <NuxtImg
                  preset="thumb"
                  quality="25"
                  :src="item.images || '/assets/logo-bali-bikes-main.png'"
                  :alt="`testimonials-${i}`"
                  class="object-cover bg-white h-full !h-[25vh] lg:h-[25vh] w-full rounded-xl"
                />
                <!-- <div class="mt-4 text-base truncate">{{ item.name }}</div>
                <div class="flex items-center gap-1">
                  <Icon
                    name="material-symbols:star-rounded"
                    v-for="(_, i) in item.rating"
                    class="size-5 text-yellow-500"
                  />
                </div> -->
              </SwiperSlide>
            </Swiper>
          </ClientOnly>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card {
  background: white;
  border-radius: 8px;
  overflow: hidden;
}

.swiper-slide {
  display: flex;
  height: 100%;
}
</style>
